import { render, staticRenderFns } from "./discount-goods-list.vue?vue&type=template&id=56ffd082&scoped=true&"
import script from "./discount-goods-list.vue?vue&type=script&lang=js&"
export * from "./discount-goods-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ffd082",
  null
  
)

export default component.exports